import { translationScopeService } from '../translation-scope.service';

export type LanguageLoader = (lang: string) => Promise<unknown>;

/**
 * Class decorator factory for marking a class as using labels from a specific label scope and
 * also provides a loader function for loading labels for that label scope.
 *
 * Usage example:
 *   @shUseTranslation('scMyScope', (lang: string) => import(`../../../i18/{lang}`))
 *   export class MyClassUsingTranslations {
 *       ...
 *   }
 *
 * @param scopeName Name of the label scope used
 * @param loader Loader function for loading the labels. Will be passed the label filename to load as argument,
 * but must itself prepend the path to the translation label files folder relative to the class' source file.
 * @returns The class decorator function
 */
export function shUseTranslation(scopeName: string, loader: LanguageLoader) {
	// eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
	return (_ctr: Function): void => {
		translationScopeService.requireScope(scopeName, loader);
	};
}
